export default __webpack_public_path__ + "static/media/bitcoin-svgrepo-com (1).bf76fb5b.svg";